import { Copy } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"

interface DummyRoomInformationProps {
  roomSid: string
  patientToken: string
}

const DummyRoomInformation = (props: DummyRoomInformationProps) => {
  return (
    <div className="absolute right-4 bottom-4 flex items-center justify-center rounded-lg text-white">
      <Button
        variant="circle"
        className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
        onClick={() => navigator.clipboard.writeText(props.roomSid)}>
        <Copy size={25} />
        Sid
      </Button>
      <Button
        variant="circle"
        className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
        onClick={() => navigator.clipboard.writeText(props.patientToken)}>
        <Copy size={25} />
        Token
      </Button>
    </div>
  )
}

export { DummyRoomInformation }
